module.exports = __webpack_public_path__ + "img/hospitium-12.fc34e5e2.jpg";